/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { sortOptions } from 'state/actions/embedsState/embedManagementState/content_status'
// component
import AnswerSet from 'material/embeds/content/shared/answerset/answerset';



/* ========== ~~~~~~~~~~ EMBED : ANSWER SET : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => ({
    currentContentStatus: embedsState.embedManagementState.contentStatus['contents'][contentId],
    numberOfOptions: Object.keys(embedsState.embedManagementState.contentStatus['contents'][contentId]['questionBased']['options']).length,
    location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location
});

// map actions
const mapDispatchToProps = dispatch => ({
    sortOptions: (contentId, options) => dispatch(sortOptions(contentId, options))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AnswerSet);
